var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-preview-card"
  }, [_c('CompanyCard', {
    attrs: {
      "company": _vm.company
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afa68a8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/onboarding/preview-card.vue
// module id = null
// module chunks = 